<template>
<div>
<v-text-field
    :label=label
    :value="value_pretty_print"
    disabled
    :hint="show_hint_everywhere ? hint : null"
    :persistent-hint="show_hint_everywhere"
    v-if="read_only == false"
    autocomplete="off"
>

    <span
        slot="append-outer"
    >
         <m-edit-menu
            v-if="!read_only"
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
         />

        <m-edit-text-dialog
            ref="edit-dialog"
            v-if="!read_only"
            :rules="validationRules()"
            v-on:ok="setValue($event)"
            :unset_label="unset_label"
            :slider_min="slider_min"
            :slider_max="slider_max"
            :slider_step="slider_step"
            :default_value="default_value"
            :edit_help_text="edit_help_text"
        />

        <m-edit-duration-dialog
            ref="edit-duration-dialog"
            v-if="!read_only"
            :rules="validationRules()"
            v-on:ok="setValue($event)"
            :unset_label="unset_label"
        />

    </span>

</v-text-field>
<m-display-text
    v-else
    :label="label"
    :value="value_pretty_print"
    :hyperlink="hyperlink"
    :copy_check="copy_check"
/>
</div>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');

export default {
    props: {

        label: {
            type: String,
            default: function () { return ''; }
        },

        value: {
            type: [String, Number],
            default: function() { return ''; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        hyperlink: {
            type: Boolean,
            default: function() { return false; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        integer: {
            type: Boolean,
            default: function() { return false; }
        },

        integer_positive: {
            type: Boolean,
            default: function() { return false; }
        },

        duration: {
            type: Boolean,
            default: function() { return false; }
        },

        integer_positive_non_zero: {
            type: Boolean,
            default: function() { return false; }
        },

        html_color: {
            type: Boolean,
            default: function() { return false; }
        },

        vanity_url_portion: {
            type: Boolean,
            default: function() { return false; }
        },

        rules: {
            type: Array,
            default: function() { return []; }
        },

        hint : {
            type: String,
            default: function() { return null; }
        },

        show_hint_everywhere: {
            type: Boolean,
            default: function() { return false; }
        },

        help_text : {
            type: String,
            default: function() { return null; }
        },

        index: {
            type: Number,
            default: function() { return -1; }
        },

        custom_on_edit: {
            type: Function,
            default: null,
        },

        copy_check: {
            type: Boolean,
            default: function() { return false; },
        },

        unset_label: {
            type: String,
            default: function() { return null; }
        },

        slider_min: {
            type: [Number,String],
            default: function() { return null; }
        },

        slider_max: {
            type: [Number,String],
            default: function() { return null; }
        },

        slider_step: {
            type: [Number,String],
            default: function() { return null; }
        },

        default_value: {
            type: [Number, String],
            default: function() { return null; }
        },

        edit_help_text: {
            type: String,
            default: function() { return null; }
        }

    },

    methods: 
    {
        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'edit' )
            {
                this.onEdit();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
            if ( this.custom_on_edit != null )
            {
                this.custom_on_edit();
            }
            else if ( this.duration == true )
            {
                this.$refs['edit-duration-dialog'].showDialog(this.label, this.value, this.hint, this.help_text);
            }
            else
            {
                this.$refs['edit-dialog'].showDialog(this.label, this.value, this.hint, this.help_text);
            }
        },

        setValue(new_value)
        {
            this.$emit('input',new_value, this.index);
        },

        validationRules()
        {
            let required = value => {
                if ( value == null ) return 'Required.';
                if ( (''+value).trim().length == 0 ) return 'Required.';
                return true;
            };

            let integer = value => {
                if ( value == null ) return 'Must be an integer';
                if ( isNaN(Number(value)) || Number(value) != parseInt(value) ) return 'Must be an integer';
                return true;
            };

            let integer_positive = value => {
               let int_value = Number(value);
               if ( isNaN(int_value) || int_value < 0 || int_value != parseInt(value) ) return 'Must be a positive integer';
               return true;
            };

            let integer_positive_non_zero = value => {
               let int_value = Number(value);
               if ( isNaN(int_value) || int_value < 1 || int_value != parseInt(value) ) return 'Must be a non-zero positive integer';
               return true;
            };

            let html_color = value => {
                return /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(value);
            };

            let vanity_url_portion = value => {
                return /^[-a-z0-9A-Z]*$/i.test(value);
            };

            let ret = _.cloneDeep(this.rules);
            
            if ( !this.optional )
                ret.push(required);
            
            if ( this.integer || this.duration == true )
                ret.push(integer);

            if ( this.integer_positive )
                ret.push(integer_positive);

            if ( this.integer_positive_non_zero )
                ret.push(integer_positive_non_zero);

            if ( this.html_color )
                ret.push(html_color);

            if ( this.vanity_url_portion )
                ret.push(vanity_url_portion);


            return ret;
        }
    },

    computed: {
        value_pretty_print() 
        {
            if ( this.value == null ) return null;
            if ( this.duration != true ) return this.value;

            return Time.prettyPrintDuration(this.value);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>